import { useKeycloak } from "@react-keycloak/web";
import * as React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../store/ActionTypes";
import { signout } from "../../../store/AppActions";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { ThemePaletteState } from "@vwpfs/mary-air-lib/theme/_Types";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";

interface DispatchProps {
    signout: () => void;
}

interface OwnProps {
    noIcon?: boolean;
    label?: string;
    onSuccess?: () => void;
}


type Props = DispatchProps & OwnProps;

export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    signout: () => dispatch(signout()),
});

const LogoutBtnComp: React.FC<Props> = (props) => {
    const { keycloak } = useKeycloak();
    return (
        props.noIcon ?
            <Button
                link={{ onClick: () => {
                    props.signout();
                    keycloak?.logout({redirectUri: import.meta.env.VITE_APP_URL}).then(() => {
                        console.log("Iris: Logout success");
                    }).catch(() => {
                        console.log("Iris: Logout failed");
                    });
                    props.onSuccess?.();
                } }}
                theme={{paletteState: ThemePaletteState.DANGER}}
            >
                {props.label ? props.label : "Logout"}
            </Button>
            : <Button
                link={{ onClick: () => {
                    props.signout();
                    keycloak?.logout({redirectUri: import.meta.env.VITE_APP_URL}).then(() => {
                        console.log("Iris: Logout success");
                    }).catch(() => {
                        console.log("Iris: Logout failed");
                    });
                    props.onSuccess?.();
                } }}
                icon={IconNames.POWER_OFF}
                className={"scl-o-navbar__icon"}
            />
    );
};

/**
 *
 */
export const LogoutBtn = connect(
    undefined,
    mapDispatchToProps,
)(LogoutBtnComp);
